//import { default as LogHandler, LogType } from "@/helpers/utilities/Handlers/LogHandler";
import LogHandler from "@/helpers/utilities/Handlers/LogHandler";

const emptyFolderTemplate = {
  name: "Folder",
  icon: ["fas", "folder"],
  color: "#ffda6a"
};

const linkTemplate = {
  name: "Link",
  icon: ["fas", "link"],
  color: "#"
};

export default {
  fileExtensions: {
    /* office365 */
    doc: {
      name: "Word",
      extension: "doc",
      nameExt: "Microsoft Word",
      skboUpload: true,
      icon: ["far", "file-word"],
      isOff365: true,
      type: "application/msword",
      color: "#185ABD"
    },
    dot: {
      name: "Word Template",
      extension: "dot",
      nameExt: "Microsoft Word",
      skboUpload: true,
      icon: ["far", "file-word"],
      isOff365: true,
      type: "application/msword",
      color: "#185ABD"
    },
    dotm: {
      name: "Word Template",
      extension: "dotm",
      nameExt: "Microsoft Word",
      skboUpload: true,
      icon: ["far", "file-word"],
      isOff365: true,
      type: "application/msword",
      color: "#185ABD"
    },
    docx: {
      name: "Word",
      extension: "docx",
      nameExt: "Microsoft Word",
      skboUpload: true,
      icon: ["far", "file-word"],
      isOff365: true,
      type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      color: "#185ABD"
    },
    dotx: {
      name: "Word Template",
      extension: "dotx",
      nameExt: "Microsoft Word",
      skboUpload: true,
      icon: ["far", "file-word"],
      isOff365: true,
      type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      color: "#185ABD"
    },
    docm: {
      name: "Word",
      nameExt: "Microsoft Word",
      skboUpload: true,
      icon: ["far", "file-word"],
      isOff365: true,
      type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      color: "#185ABD"
    },
    pptx: {
      name: "PowerPoint",
      extension: "pptx",
      nameExt: "Microsoft PowerPoint",
      skboUpload: true,
      icon: ["far", "file-powerpoint"],
      isOff365: true,
      color: "#DD5B26",
      type: "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    },
    pptm: {
      name: "PowerPoint",
      extension: "pptm",
      nameExt: "Microsoft PowerPoint",
      skboUpload: true,
      icon: ["far", "file-powerpoint"],
      isOff365: true,
      color: "#DD5B26",
      type: "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    },
    xlsx: {
      name: "Excel",
      extension: "xlsx",
      nameExt: "Microsoft Excel",
      skboUpload: true,
      icon: ["far", "file-excel"],
      isOff365: true,
      color: "#1D6F42",
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    },
    xlsm: {
      name: "Excel",
      extension: "xlsm",
      nameExt: "Microsoft Excel",
      skboUpload: true,
      icon: ["far", "file-excel"],
      isOff365: true,
      color: "#1D6F42",
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    },
    one: {
      name: "OneNote",
      nameExt: "Microsoft OneNote",
      skboUpload: true,
      icon: ["far", "file"],
      isOff365: true,
      color: "#7719AA"
    },
    ppt: {
      name: "PowerPoint",
      extension: "ppt",
      nameExt: "Microsoft PowerPoint 97",
      skboUpload: true,
      icon: ["far", "file-powerpoint"],
      isOff365: true,
      color: "#DD5B26",
      type: "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    },
    pps: {
      name: "PowerPoint",
      extension: "pps",
      nameExt: "Microsoft PowerPoint",
      skboUpload: true,
      icon: ["far", "file-powerpoint"],
      isOff365: true,
      color: "#DD5B26",
      type: "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    },
    ppsm: {
      name: "PowerPoint",
      extension: "ppsm",
      nameExt: "Microsoft PowerPoint",
      skboUpload: true,
      icon: ["far", "file-powerpoint"],
      isOff365: true,
      color: "#DD5B26",
      type: "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    },
    ppsx: {
      name: "PowerPoint",
      extension: "ppsx",
      nameExt: "Microsoft PowerPoint",
      skboUpload: true,
      icon: ["far", "file-powerpoint"],
      isOff365: true,
      color: "#DD5B26",
      type: "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    },
    msg: {
      name: "Outlook",
      nameExt: "Microsoft Outlook",
      skboUpload: true,
      icon: ["far", "envelope"],
      isOff365: true,
      color: "#5c5e5f"
    },
    xls: {
      name: "Excel",
      extension: "xls",
      nameExt: "Microsoft Excel 97",
      skboUpload: true,
      icon: ["far", "file-excel"],
      isOff365: true,
      color: "#1D6F42"
    } /*
    accdb: {
      name: "Access",
      nameExt: "Microsoft Access",
      skboUpload: false,
      icon: ["fas", "database"],
      isOff365: true,
      color: "#5c5e5f"
    },*/,
    /* OTHER */
    mkv: {
      name: "Video",
      extension: "mkv",
      nameExt: "mkv",
      skboUpload: true,
      icon: ["far", "file-video"],
      maxSize: 60000000,
      isOff365: false,
      color: "#5c5e5f"
    },
    mp4: {
      name: "Video",
      extension: "mp4",
      nameExt: "mp4",
      skboUpload: true,
      icon: ["far", "file-video"],
      maxSize: 60000000,
      isOff365: false,
      color: "#5c5e5f"
    },
    mpg: {
      name: "Video",
      extension: "mp4",
      nameExt: "mp4",
      skboUpload: true,
      icon: ["far", "file-video"],
      maxSize: 60000000,
      isOff365: false,
      color: "#5c5e5f"
    },
    mov: {
      name: "Video",
      extension: "mov",
      nameExt: "mov",
      skboUpload: true,
      icon: ["far", "file-video"],
      maxSize: 60000000,
      isOff365: false,
      color: "#5c5e5f"
    },
    jpg: {
      name: "Image",
      extension: "jpg",
      nameExt: "jpg",
      skboUpload: true,
      icon: ["far", "file-image"],
      maxSize: 1048576,
      isOff365: false,
      color: "#5c5e5f"
    },
    jpeg: {
      name: "Image",
      extension: "jpeg",
      nameExt: "jpeg",
      skboUpload: true,
      icon: ["far", "file-image"],
      maxSize: 1048576,
      isOff365: false,
      color: "#5c5e5f"
    },
    jfif: {
      name: "Image",
      extension: "jfif",
      nameExt: "jfif",
      skboUpload: true,
      icon: ["far", "file-image"],
      maxSize: 1048576,
      isOff365: false,
      color: "#5c5e5f"
    },
    bmp: {
      name: "Image",
      extension: "bmp",
      nameExt: "bmp",
      skboUpload: true,
      icon: ["far", "file-image"],
      maxSize: 1048576,
      isOff365: false,
      color: "#5c5e5f"
    },
    png: {
      name: "Image",
      extension: "png",
      nameExt: "png",
      skboUpload: true,
      icon: ["far", "file-image"],
      maxSize: 1048576,
      isOff365: false,
      color: "#5c5e5f"
    },
    pdn: {
      name: "Image",
      extension: "pdn",
      nameExt: "pdn",
      skboUpload: true,
      icon: ["far", "file-image"],
      maxSize: 1048576,
      isOff365: false,
      color: "#5c5e5f"
    },
    gif: {
      name: "Image",
      extension: "gif",
      nameExt: "gif",
      skboUpload: true,
      icon: ["far", "file-image"],
      maxSize: 1048576,
      isOff365: false,
      color: "#5c5e5f"
    },
    svg: {
      name: "Scalable Vector",
      extension: "svg",
      nameExt: "svg",
      skboUpload: true,
      icon: ["far", "file-image"],
      maxSize: 1048576,
      isOff365: false,
      color: "#5c5e5f"
    },
    webp: {
      name: "WebP Image",
      extension: "webp",
      nameExt: "webp",
      skboUpload: true,
      icon: ["far", "file-image"],
      maxSize: 1048576,
      isOff365: false,
      color: "#5c5e5f"
    },
    dxf: {
      name: "CAD Drawing",
      extension: "dxf",
      nameExt: "dxf",
      skboUpload: true,
      icon: ["far", "file-image"],
      maxSize: 1048576,
      isOff365: false,
      color: "#5c5e5f"
    },
    dwg: {
      name: "CAD Drawing",
      extension: "dwg",
      nameExt: "dwg",
      skboUpload: true,
      icon: ["far", "file-image"],
      maxSize: 1048576,
      isOff365: false,
      color: "#5c5e5f"
    },
    stl: {
      name: "Stereolithography Drawing",
      extension: "stl",
      nameExt: "stl",
      skboUpload: true,
      icon: ["far", "file-image"],
      maxSize: 1048576,
      isOff365: false,
      color: "#5c5e5f"
    },
    xcf: {
      name: "GIMP Image",
      extension: "xcf",
      nameExt: "xcf",
      skboUpload: true,
      icon: ["far", "file-image"],
      maxSize: 1048576,
      isOff365: false,
      color: "#5c5e5f"
    },
    tif: {
      name: "Image",
      extension: "tif",
      nameExt: "tif",
      skboUpload: true,
      icon: ["far", "file-image"],
      maxSize: 1048576,
      isOff365: false,
      color: "#5c5e5f"
    },
    tiff: {
      name: "Image",
      extension: "tif",
      nameExt: "tif",
      skboUpload: true,
      icon: ["far", "file-image"],
      maxSize: 1048576,
      isOff365: false,
      color: "#5c5e5f"
    },
    mp3: {
      name: "Audio",
      extension: "mp3",
      nameExt: "mp3",
      skboUpload: true,
      icon: ["far", "file-audio"],
      maxSize: 1048576,
      isOff365: false,
      color: "#5c5e5f"
    },
    url: {
      name: "Link",
      extension: "url",
      nameExt: "Link",
      skboUpload: true,
      icon: ["far", "file"],
      maxSize: 1048576,
      isOff365: false,
      color: "#5c5e5f"
    },
    txt: {
      name: "Text Document",
      extension: "txt",
      nameExt: "txt",
      skboUpload: true,
      icon: ["far", "file"],
      isOff365: false,
      color: "#5c5e5f"
    },
    odt: {
      name: "Text Document",
      nameExt: "odt",
      skboUpload: true,
      icon: ["far", "file"],
      isOff365: false,
      color: "#5c5e5f"
    },
    odx: {
      name: "SpreadSheet",
      nameExt: "odx",
      skboUpload: true,
      icon: ["far", "file"],
      isOff365: false,
      color: "#5c5e5f"
    },
    ods: {
      name: "SpreadSheet",
      nameExt: "ods",
      skboUpload: true,
      icon: ["far", "file"],
      isOff365: false,
      color: "#5c5e5f"
    },
    odp: {
      name: "Presentation",
      nameExt: "odp",
      skboUpload: true,
      icon: ["far", "file"],
      isOff365: false,
      color: "#5c5e5f"
    },
    pages: {
      name: "Pages Text",
      extension: "pages",
      nameExt: "pages",
      skboUpload: true,
      icon: ["far", "file"],
      isOff365: false,
      color: "#5c5e5f"
    },
    rtf: {
      name: "Rich Text",
      extension: "rtf",
      nameExt: "rtf",
      skboUpload: true,
      icon: ["far", "file"],
      isOff365: false,
      color: "#5c5e5f"
    },
    csv: {
      name: "Comma Separated",
      extension: "csv",
      nameExt: "csv",
      skboUpload: true,
      icon: ["far", "file"],
      isOff365: false,
      color: "#5c5e5f"
    },
    ino: {
      name: "Arduino Sketch",
      extension: "ino",
      nameExt: "ino",
      skboUpload: true,
      icon: ["far", "file-code"],
      isOff365: false,
      color: "#5c5e5f"
    },
    py: {
      name: "Python script",
      extension: "py",
      nameExt: "py",
      skboUpload: true,
      icon: ["far", "file-code"],
      isOff365: false,
      color: "#5c5e5f"
    },
    log: {
      name: "Log file",
      extension: "log",
      nameExt: "log",
      skboUpload: true,
      icon: ["far", "file"],
      isOff365: false,
      color: "#5c5e5f"
    },
    aup: {
      name: "Audacity Project",
      extension: "aup",
      nameExt: "aup",
      skboUpload: true,
      icon: ["far", "file-audio"],
      isOff365: false,
      color: "#5c5e5f"
    },
    m4a: {
      name: "MPEG-4 Audio",
      extension: "m4a",
      nameExt: "m4a",
      skboUpload: true,
      icon: ["far", "file-audio"],
      isOff365: false,
      color: "#5c5e5f"
    },
    wav: {
      name: "Wave Audio",
      extension: "wav",
      nameExt: "wav",
      skboUpload: true,
      icon: ["far", "file-audio"],
      isOff365: false,
      color: "#5c5e5f"
    },
    pdf: {
      name: "PDF",
      extension: "pdf",
      nameExt: "PDF",
      skboUpload: true,
      icon: ["far", "file-pdf"],
      isOff365: false,
      type: "application/pdf",
      color: "#F25123"
    },
    prn: {
      name: "Print",
      extension: "prn",
      nameExt: "prn",
      skboUpload: true,
      icon: ["far", "file"],
      isOff365: false,
      color: "#F25123"
    },
    exe: {
      name: "Program",
      extension: "exe",
      nameExt: "Program",
      skboUpload: false,
      icon: ["far", "xmark-circle"],
      isOff365: false,
      color: "#5c5e5f"
    },
    msi: {
      name: "Program",
      extension: "msi",
      nameExt: "Program",
      skboUpload: false,
      icon: ["far", "xmark-circle"],
      isOff365: false,
      color: "#5c5e5f"
    },
    bat: {
      name: "Batch file",
      extension: "bat",
      nameExt: "Batch file",
      skboUpload: false,
      icon: ["far", "xmark-circle"],
      isOff365: false,
      color: "#5c5e5f"
    },
    zip: {
      name: "ZIP file",
      nameExt: "ZIP Archive",
      skboUpload: true,
      icon: ["fas", "file-archive"],
      isOff365: false,
      color: "#5c5e5f"
    },
    rar: {
      name: "RAR file",
      nameExt: "RAT Archive",
      skboUpload: true,
      icon: ["fas", "file-archive"],
      isOff365: false,
      color: "#5c5e5f"
    },
    /* OTHER SPECIEL */
    ggb: {
      name: "GeoGebra",
      extension: "ggb",
      nameExt: "GeoGebra",
      skboUpload: true,
      icon: "GeoGebra.svg",
      isOff365: false,
      color: "#5c5e5f"
    },
    bm2: {
      name: "BoardMaker",
      nameExt: "BoardMaker",
      skboUpload: true,
      icon: ["far", "file"],
      isOff365: false,
      color: "#5c5e5f"
    },
    mht: {
      name: "Web Archive",
      nameExt: "Web Archive",
      skboUpload: true,
      icon: ["far", "file"],
      isOff365: false,
      color: "#5c5e5f"
    },
    pub: {
      name: "Publisher",
      nameExt: "Publisher",
      skboUpload: true,
      icon: ["far", "file"],
      isOff365: false,
      color: "#5c5e5f"
    },
    lnk: {
      name: "Shortcut",
      nameExt: "Shortcut",
      skboUpload: true,
      icon: ["fas", "link"],
      isOff365: false,
      color: "#5c5e5f"
    },
    ini: {
      name: "Init",
      nameExt: "Windows Init",
      skboUpload: false,
      icon: ["far", "xmark-circle"],
      isOff365: false,
      color: "#5c5e5f"
    },
    htm: {
      name: "HTML Document",
      extension: "htm",
      nameExt: "htm",
      skboUpload: true,
      icon: ["far", "file-code"],
      maxSize: 1048576,
      isOff365: false,
      color: "#5c5e5f"
    },
    html: {
      name: "HTML Document",
      extension: "html",
      nameExt: "html",
      skboUpload: true,
      icon: ["far", "file-code"],
      maxSize: 1048576,
      isOff365: false,
      color: "#5c5e5f"
    },
    css: {
      name: "Cascading Style Sheet",
      extension: "css",
      nameExt: "css",
      skboUpload: true,
      icon: ["far", "file-code"],
      maxSize: 1048576,
      isOff365: false,
      color: "#5c5e5f"
    },
    hex: {
      name: "Hexadecimal Source",
      extension: "hex",
      nameExt: "hex",
      skboUpload: true,
      icon: ["far", "file-code"],
      maxSize: 1048576,
      isOff365: false,
      color: "#5c5e5f"
    },
    js: {
      name: "JavaScript",
      extension: "js",
      nameExt: "js",
      skboUpload: true,
      icon: ["far", "file-code"],
      maxSize: 1048576,
      isOff365: false,
      color: "#5c5e5f"
    },
    json: {
      name: "JavaScript",
      extension: "json",
      nameExt: "json",
      skboUpload: true,
      icon: ["far", "file-code"],
      maxSize: 1048576,
      isOff365: false,
      color: "#5c5e5f"
    },
    webm: {
      name: "WebM video",
      extension: "webm",
      nameExt: "webm",
      skboUpload: true,
      icon: ["far", "file-video"],
      maxSize: 1048576,
      isOff365: false,
      color: "#5c5e5f"
    },
    wmv: {
      name: "Windows Media Video",
      extension: "wmv",
      nameExt: "wmv",
      skboUpload: true,
      icon: ["far", "file-video"],
      maxSize: 1048576,
      isOff365: false,
      color: "#5c5e5f"
    },
    avi: {
      name: "Audio Video",
      extension: "avi",
      nameExt: "avi",
      skboUpload: true,
      icon: ["far", "file-video"],
      maxSize: 1048576,
      isOff365: false,
      color: "#5c5e5f"
    },
    cip: {
      name: "CryptoBuddy",
      extension: "cip",
      nameExt: "CryptoBuddy",
      skboUpload: true,
      icon: ["fas", "file-archive"],
      isOff365: false,
      color: "#5c5e5f"
    },
    notebook: {
      name: "SMART Notebook",
      extension: "notebook",
      nameExt: "SMART Notebook",
      skboUpload: true,
      icon: ["fas", "file-archive"],
      isOff365: false,
      color: "#5c5e5f"
    },
    alk: {
      name: "Eplan database",
      extension: "alk",
      nameExt: "Eplan database",
      skboUpload: true,
      icon: ["fas", "database"],
      isOff365: false,
      color: "#5c5e5f"
    },
    mdb: {
      name: "Microsoft database",
      extension: "mdb",
      nameExt: "Microsoft Access Database",
      skboUpload: true,
      icon: ["fas", "database"],
      isOff365: false,
      color: "#5c5e5f"
    },
    eps: {
      name: "Encapsulated PostScript",
      extension: "eps",
      nameExt: "Encapsulated PostScript",
      skboUpload: true,
      icon: ["far", "file-image"],
      isOff365: false,
      color: "#5c5e5f"
    },
    ai: {
      name: "Illustrator",
      extension: "ai",
      nameExt: "Adobe Illustrator",
      skboUpload: true,
      icon: ["far", "file-image"],
      isOff365: false,
      color: "#5c5e5f"
    }
  },

  addExtensionsToArrayOfFiles(payload) {
    const items = [];

    for (const key in payload) {
      const children = payload;

      if (Object.prototype.hasOwnProperty.call(children, key)) {
        const element = children[key];
        if (
          (element.package && element.package.type === "oneNote") ||
          (element.remoteItem && element.remoteItem.package && element.remoteItem.package.type === "oneNote")
        ) {
          element.extension = this.fileExtensions.one;
          items.push(element);
        } else if (element.folder) {
          element.extension = this.getClosedFolderTemplate();
          items.push(element);
        } else {
          element.extension = this.getFileExtensionObject(element.name);
          items.push(element);
        }
      }
    }
    return items;
  },

  getFileExtensionObject(name) {
    const extensionRegex = /(?:\.([^.]+))?$/;
    const check = extensionRegex.exec(name);
    let extName = "";
    if (check && check[1]) {
      extName = check[1].toLocaleLowerCase();
    }

    if (Object.prototype.hasOwnProperty.call(this.fileExtensions, extName)) {
      return { ...this.fileExtensions[extName] };
    } else {
      if (extName === "") {
        return this.getClosedFolderTemplate();
      } else {
        // Don't register empty extensions - the occur
        // Empty extension
        if (!extName.includes("json")) {
          LogHandler.log("message", "Missing extension icon", extName, {
            fileName: name
          });
        }
      }

      return {
        name: "",
        nameExt: "",
        skboUpload: false,
        icon: ["far", "file"],
        isOff365: false,
        color: "#E5EAED"
      };
    }
  },

  getFileAsBinary(file) {
    return new Promise(resolve => {
      const fileReader = new FileReader();

      fileReader.onload = function () {
        const data = fileReader.result;
        resolve(data);
      };

      fileReader.readAsArrayBuffer(file);
    });
  },

  getClosedFolderTemplate() {
    return Object.assign({}, emptyFolderTemplate);
  },

  getLinkTemplate() {
    return linkTemplate;
  },

  getFileOdataType(fileMimeType) {
    const type = this.fileMimeTypeToOdataType[fileMimeType];
    return type ? type : "#microsoft.graph.educationFileResource";
  },

  fileMimeTypeToOdataType: {
    "application/msword": "#microsoft.graph.educationWordResource",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "#microsoft.graph.educationWordResource",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.template": "#microsoft.graph.educationWordResource",
    "application/vnd.ms-word.template.macroEnabled.12": "#microsoft.graph.educationWordResource",
    "application/vnd.ms-excel": "#microsoft.graph.educationExcelResource",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "#microsoft.graph.educationExcelResource",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template": "#microsoft.graph.educationExcelResource",
    "application/vnd.ms-excel.sheet.macroEnabled.12": "#microsoft.graph.educationExcelResource",
    "application/vnd.ms-excel.template.macroEnabled.12": "#microsoft.graph.educationExcelResource",
    "application/vnd.ms-excel.addin.macroEnabled.12": "#microsoft.graph.educationExcelResource",
    "application/vnd.ms-excel.sheet.binary.macroEnabled.12": "#microsoft.graph.educationExcelResource",
    "application/vnd.ms-powerpoint": "#microsoft.graph.educationPowerPointResource",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      "#microsoft.graph.educationPowerPointResource",
    "application/vnd.openxmlformats-officedocument.presentationml.template":
      "#microsoft.graph.educationPowerPointResource",
    "application/vnd.openxmlformats-officedocument.presentationml.slideshow":
      "#microsoft.graph.educationPowerPointResource",
    "application/vnd.ms-powerpoint.addin.macroEnabled.12": "#microsoft.graph.educationPowerPointResource",
    "application/vnd.ms-powerpoint.presentation.macroEnabled.12": "#microsoft.graph.educationPowerPointResource",
    "application/vnd.ms-powerpoint.template.macroEnabled.12": "#microsoft.graph.educationPowerPointResource",
    "application/vnd.ms-powerpoint.slideshow.macroEnabled.12": "#microsoft.graph.educationPowerPointResource"
  }
};
